import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import MainLayout from './components/MainLayout'
import Navigation from './components/Navigation'
import Home from './pages/Home'
import Sections from './pages/Sections'
import TutorInfo from './pages/TutorInfo'
import TutorProfile from './pages/TutorProfile'
import ResearchGroups from './pages/ResearchGroups'
import ResearchGroupsInfo from './pages/ResearchGroupsInfo'
import JoinResearch from './pages/JoinResearch'
import CreateResearchGroupInfo from './pages/CreateResearchGroupInfo'
import About from './pages/About'
import VolunteeringRules from './pages/VolunteeringRules'
import Login from './pages/Login'
import Register from './pages/Register'
import Wall from './pages/Wall'
import Dashboard from './pages/Dashboard'
import CreateCourse from './pages/CreateCourse'
import JoinCourse from './pages/JoinCourse'
import CourseDetail from './pages/CourseDetail'
import ProfileEditor from './pages/ProfileEditor'
import Tutors from './pages/Tutors'
import ResearchForms from './pages/ResearchForms'
import Library from './pages/Library'
import RetiredTutors from './pages/RetiredTutors'
import './App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
            {/* Rutas públicas sin Header */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Rutas públicas con Header */}
            {/* Rutas públicas con Header */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/secciones" element={<Sections />} />
              <Route path="/tutores" element={<Tutors />} />
              <Route path="/mural-retiro" element={<RetiredTutors />} />
              <Route path="/tutor/:tutorId" element={<TutorProfile />} />
              <Route path="/como-ser-tutor" element={<TutorInfo />} />
              <Route path="/grupos-investigacion" element={<ResearchGroups />} />
              <Route path="/research-group/:id" element={<ResearchGroupsInfo />} />
              <Route path="/como-unirse-investigacion" element={<JoinResearch />} />
              <Route path="/crear-grupo-investigacion" element={<CreateResearchGroupInfo />} />
              <Route path="/formularios-investigacion" element={<ResearchForms />} />
              <Route path="/nosotros" element={<About />} />
              <Route path="/muro" element={<Wall />} />
              <Route path="/reglamento" element={<VolunteeringRules />} />
              <Route path="/biblioteca" element={<Library />} />
            </Route>

            {/* Rutas protegidas del dashboard */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/profile" element={
              <ProtectedRoute>
                <ProfileEditor />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/create-course" element={
              <ProtectedRoute>
                <CreateCourse />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/join-course/:courseId" element={
              <ProtectedRoute>
                <JoinCourse />
              </ProtectedRoute>
            } />
            <Route path="/dashboard/course/:courseId" element={
              <ProtectedRoute>
                <CourseDetail />
              </ProtectedRoute>
            } />

            {/* Redirección por defecto */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
  )
}

export default App
